import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadIcon = _resolveComponent("UploadIcon")!
  const _component_NcButton = _resolveComponent("NcButton")!

  return (_openBlock(), _createBlock(_component_NcButton, {
    class: "memories-menu-item upload-menu",
    variant: "tertiary-no-background",
    title: _ctx.t('memories', 'Upload'),
    "aria-label": _ctx.t('memories', 'Upload'),
    onClick: _ctx.upload
  }, {
    icon: _withCtx(() => [
      _createVNode(_component_UploadIcon, { size: 20 })
    ]),
    _: 1
  }, 8, ["title", "aria-label", "onClick"]))
}